








































import { Component, Mixins } from 'vue-property-decorator'
import { IntlMixin } from '../vuemixins/intl_mixin'
import BaseButtonIcon from 'library/v4/components/base-button-icon.vue'
import BaseIcon from 'vuecomponents/base_button.vue'
import PadletLogo from 'vuecomponents/padlet_logo.vue'
import SidebarFooter from 'vuecomponents/sidebar_footer.vue'
import { __ } from 'bits/intl'

const authButtons = {
  login: {
    href: '/auth/login',
    size: 'normal',
    colorScheme: 'white',
    iconName: 'forward_button',
    position: 'top',
    secondIcon: 'true',
    secondIconName: 'forward',
    border: 'true',
    class: 'login-button',
    text: __('Log in'),
  },
  signUp: {
    href: '/auth/signup',
    size: 'normal',
    colorScheme: 'white',
    iconName: 'sign_up',
    position: 'bottom',
    secondIcon: 'true',
    secondIconName: 'forward',
    border: 'true',
    text: __('Sign up'),
  },
}

const homeAuthButton = {
  login: {
    href: '/auth/login',
    size: 'normal',
    colorScheme: 'white',
    iconName: 'forward_button',
    secondIcon: 'true',
    secondIconName: 'forward',
    border: 'true',
    text: __('Log in'),
  },
}

const navButtons = {
  home: {
    id: 'nav-home',
    href: '/',
    iconName: 'home',
    text: __('Home'),
  },
  product: {
    id: 'nav-product',
    href: '/features',
    iconName: 'cupcake_filled',
    text: __('Product'),
  },
  personal: {
    id: 'nav-personal',
    href: '/premium/pro',
    iconName: 'user',
    text: __('Personal'),
  },
  business: {
    id: 'nav-business',
    href: '/premium/briefcase',
    iconName: 'briefcase',
    text: __('Business'),
  },
  schools: {
    id: 'nav-school',
    href: '/premium/backpack',
    iconName: 'course',
    text: __('Schools'),
  },
}

@Component({
  components: {
    BaseButtonIcon,
    PadletLogo,
    SidebarFooter,
    BaseIcon,
  },
})
export default class BaseSidebar extends Mixins(IntlMixin) {
  navButtons = navButtons
  authButtons = authButtons
  homeAuthButton = homeAuthButton
  authButtonList: object | null = null

  mounted() {
    if (window.location.href.includes('/memberships')) {
      document.getElementById('nav-membership')?.classList.add('active')
      this.authButtonList = this.authButtons
    } else if (window.location.href.includes('/features')) {
      document.getElementById('nav-product')?.classList.add('active-product')
      this.authButtonList = this.authButtons
    } else {
      document.getElementById('nav-home')?.classList.add('active-home')
      this.authButtonList = this.homeAuthButton
    }
  }
}
